<div class="main-container">
    <p>คุณอาจสนใจข่าวนี้</p>
    <div class="skeleton" [ngClass]="{'hidden': !loading}">
        <div>
            <p-skeleton *ngFor="let i of [1, 2, 3, 4]" height="30vh" width="20vw"></p-skeleton>
        </div>
        <br>
        <br>
        <div>
            <p-skeleton *ngFor="let i of [1, 2, 3, 4]" height="30vh" width="20vw"></p-skeleton>   
        </div>
    </div>
    <div class="news-container" [ngClass]="{'hidden': loading}">
        <p-card *ngFor="let news of suggestNews" (click)="onNewsClick(news)">   
            <img class="photo" [src]="news.Picture_URL_OD" [alt]="news.Picture_Alt_OD" (error)="onImageError($event)"  width="100%" style="border-radius: 16px; aspect-ratio: 5 / 3;">
            <div class="title-container">
                <img [src]="news.icon" alt="news_source_icon">
                <h4 
                style="overflow: hidden; 
                text-overflow: ellipsis; 
                color: var(--title-color); 
                display: -webkit-box; 
                -webkit-box-orient: vertical; 
                -webkit-line-clamp: 2;
                margin: 0;
                min-height: 48px;">
                    {{ news.Topic_OD }}
                </h4>
            </div> 
        </p-card>
        <!-- <div class="news" *ngFor="let news of suggestNews" (click)="onNewsClick(news)">
            <img [src]="news.Picture_URL_OD" [alt]="news.Picture_Alt_OD">
            <div class="title-container">
                <img [src]="news.icon" alt="news_source_icon">
                <p>{{ news.Topic_OD }}</p>
            </div>
        </div> -->
    </div>
</div>